import { render } from "./Plus.vue?vue&type=template&id=2255383c"
import script from "./Plus.vue?vue&type=script&lang=js"
export * from "./Plus.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "2255383c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2255383c', script)) {
    api.reload('2255383c', script)
  }
  
  module.hot.accept("./Plus.vue?vue&type=template&id=2255383c", () => {
    api.rerender('2255383c', render)
  })

}

script.__file = "src/icons/components/filled/Plus.vue"

export default script